module.exports = __webpack_public_path__ + "a17d279f/img/arrow-share-icon.00a12c29.svg";